module.exports = __webpack_public_path__ + "static/media/online-timesheets.8b1dedde.png";